/*
 * Takes an arbitrary object as argument and throws an error instead of returning undefined
 * when attempting to access an property that does not exist
 */
export default function noUndefined(obj) {
  const handler = {
    get(target, property) {
      if (property in target) {
        return target[property];
      }
      throw new Error(`Property '${property}' is not defined'`);
    }
  };
  return new Proxy(obj, handler);
}
